"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var skynet_store_properties_api_1 = require("@synisys/skynet-store-properties-api");
var skynet_store_properties_impl_1 = require("@synisys/skynet-store-properties-impl");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
var ErrorObservable_1 = require("rxjs/observable/ErrorObservable");
var operators_1 = require("rxjs/operators");
var TimeoutError_1 = require("rxjs/util/TimeoutError");
var auth_utillities_1 = require("./auth.utillities");
var of_1 = require("rxjs/observable/of");
exports.IGNORE_AUTH_TOKEN = new core_1.InjectionToken('Ignore auth token');
var logger = auth_utillities_1.createLogger('auth-interceptor');
var AuthInterceptor = /** @class */ (function () {
    function AuthInterceptor(store, propertyPath, ignorePatterns) {
        this.propertyPath = propertyPath;
        this.ignorePatterns = ignorePatterns;
        this.token$ = store.select(function (state) { return state.authentication.token; });
        this.authUrl$ = skynet_store_properties_api_1.getProperties(store).pipe(operators_1.map(function (propertiesMap) {
            return lodash_1.get(propertiesMap, 'auth-service-url') ||
                lodash_1.get(propertiesMap, 'oauth-service-url');
        }), skynet_store_utilities_1.assert(skynet_store_utilities_1.notNil, new skynet_store_utilities_1.StoreManagerError('Url for auth-service-url was not found')));
    }
    AuthInterceptor_1 = AuthInterceptor;
    AuthInterceptor.addToken = function (request, token) {
        if (token) {
            return request.clone({
                setHeaders: {
                    Authorization: "Bearer " + token,
                },
            });
        }
        return request;
    };
    AuthInterceptor.isAuthRequest = function (request, authUrl) {
        return (request.method === 'POST' &&
            (request.url.startsWith(authUrl + "/oauth/token") ||
                request.url.startsWith(authUrl + "/oauth/check_token")));
    };
    AuthInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        if (this.isPropertiesRequest(request) ||
            request.headers.has('Authorization') ||
            this.isIgnorable(request)) {
            return next.handle(request);
        }
        return this.authUrl$.pipe(operators_1.first(), operators_1.timeout(2000), operators_1.catchError(function (err) {
            if (err instanceof TimeoutError_1.TimeoutError) {
                return ErrorObservable_1.ErrorObservable.create(
                // tslint:disable-next-line:max-line-length
                "Can't get properties. You need to dispatch action with type PropertiesActionTypes.GetProperties");
            }
            return ErrorObservable_1.ErrorObservable.create(err);
        }), operators_1.mergeMap(function (authUrl) {
            if (AuthInterceptor_1.isAuthRequest(request, authUrl)) {
                return next.handle(request);
            }
            return _this.token$.pipe(operators_1.first(skynet_store_utilities_1.notNil), operators_1.timeoutWith(0, of_1.of(undefined)), operators_1.mergeMap(function (token) {
                return next.handle(AuthInterceptor_1.addToken(request, token));
            }));
        }));
    };
    AuthInterceptor.prototype.isPropertiesRequest = function (request) {
        return (request.url.endsWith(lodash_1.isNil(this.propertyPath)
            ? 'app/dummy/properties.json'
            : this.propertyPath) ||
            request.url.endsWith('properties/urls') ||
            request.url.endsWith('json'));
    };
    AuthInterceptor.prototype.isIgnorable = function (request) {
        if (lodash_1.isNil(this.ignorePatterns)) {
            return false;
        }
        return this.ignorePatterns.some(function (pattern) { return pattern.match(request); });
    };
    AuthInterceptor = AuthInterceptor_1 = __decorate([
        core_1.Injectable()
        /**
         * @deprecated use AuthTokenInterceptor from @synisys/idm-authentication-client-js
         */
        ,
        __param(1, core_1.Inject(skynet_store_properties_impl_1.SERVICE_URLS_URL)),
        __param(1, core_1.Optional()),
        __param(2, core_1.Inject(exports.IGNORE_AUTH_TOKEN)),
        __param(2, core_1.Optional()),
        __metadata("design:paramtypes", [store_1.Store, Object, Object])
    ], AuthInterceptor);
    return AuthInterceptor;
    var AuthInterceptor_1;
}());
exports.AuthInterceptor = AuthInterceptor;
//# sourceMappingURL=auth.interceptor.js.map